class ModalBox {
  constructor(id) {
    this.box = document.getElementById(id)
    this.buttons = document.querySelectorAll(`[data-target="${id}"]`)
    this.close = this.box.querySelector(".modal-box__close")
    this.cover = this.box.querySelector(".modal-box__cover")
    this.listen()
  }

  listen() {
    this.buttons.forEach((button) =>
      button.addEventListener("click", () => {
        this.openModal()
      })
    )

    this.close.addEventListener("click", () => {
      this.closeModal()
    })
    addEventListener("keydown", (ev) => {
      if (ev.key === "Escape") {
        this.closeModal()
      }
    })
    this.cover.addEventListener("click", () => {
      this.closeModal()
    })
  }

  closeModal() {
    this.box.classList.remove("show")
    document.body.classList.remove("noscroll")
    if (this.box.classList.contains("modal-box--video")) {
      const iframe = this.box.querySelector("iframe")
      const newSrc = iframe.src.replace("&autoPlay=1", "")
      // Only reassign when the value actually changes — setting src reloads
      // the iframe and re-buffers the video
      if (iframe.src !== newSrc) iframe.src = newSrc
      const preview = document.querySelector(".video-preview")
      preview.play()
    }
  }
  openModal() {
    this.box.classList.add("show")
    document.body.classList.add("noscroll")
    if (this.box.classList.contains("modal-box--video")) {
      const iframe = this.box.querySelector("iframe")
      const newSrc = iframe.src + "&autoPlay=1"
      // Only reassign when the value actually changes — setting src reloads
      // the iframe and re-buffers the video
      if (iframe.src !== newSrc) iframe.src = newSrc
      const preview = document.querySelector(".video-preview")
      preview.pause()
      preview.currentTime = 0
    }
  }
}

export default ModalBox
